template = require('./holdings_show.html.slim')
controller = require('./holdings_show_controller')


angular.module('wbComponents').directive 'holdingsShow', ->
  replace: true
  restrict: 'E'
  templateUrl: template
  controller: controller
  controllerAs: 'ctrl'
